import { AppStore } from '../core/state/app-store';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DevicesService } from '../services/devices/devices.service';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { Device } from '../models/device';
import { MessageService } from 'primeng/api';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-add-devices',
  templateUrl: './add-devices.component.html',
  styleUrls: ['./add-devices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddDevicesComponent implements OnInit, OnDestroy {
  addingDevice = false;
  devices: Device[] = [];
  addNewDeviceForm: FormGroup;
  devicesSubscription: Subscription;
  constructor(
    private addDevicesService: DevicesService,
    private appStore: AppStore,
    private changeRef: ChangeDetectorRef,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {
    this.devicesSubscription = this.appStore.state$
      .pipe(
        filter(
          (currentState) =>
            !!currentState.devices && currentState.devices.length > 0
        ),
        map((currentState) => currentState.devices),
        distinctUntilChanged()
      )
      .subscribe((devices) => {
        this.devices = devices;
        this.changeRef.markForCheck();
      });
    this.addNewDeviceForm = new FormGroup({
      deviceId: new FormControl('', Validators.required),
      locatorPin: new FormControl('', Validators.required),
    });
  }
  ngOnDestroy(): void {
    if (this.devicesSubscription) {
      this.devicesSubscription.unsubscribe();
    }
  }

  onSubmitDevice(): void {
    if (this.addNewDeviceForm.valid) {
      this.addDevicesService
        .postDevice({
          deviceId: this.addNewDeviceForm.value.deviceId,
          locatorPin: this.addNewDeviceForm.value.locatorPin,
        })
        .subscribe(
          () => {
            this.messageService.add({
              severity: 'success',
              detail: this.translateService.instant(
                'main.add-devices.add-success'
              ),
              key: 'appMessage',
            });
            this.appStore.refreshDevicesInformation();
          },
          (res) => {
            let messageError;
            switch (res.status) {
              case 400: {
                switch (res.error.statusCode) {
                  case 'DEVICE_EXISTS': {
                    messageError = 'deviceExists';
                    break;
                  }
                  case 'INVALID_DEVICE_DATA': {
                    messageError = 'invalidDeviceData';
                    break;
                  }
                  case 'INVALID_DEVICE_DATA_BUSINESS_ID': {
                    messageError = 'invalidDeviceDataBusinessID';
                    break;
                  }
                  default: {
                    messageError = 'unknown';
                  }
                }
                break;
              }
              case 500: {
                messageError = 'serverError';
                break;
              }
              default: {
                messageError = 'unknown';
              }
            }
            this.messageService.add({
              severity: 'error',
              detail: this.translateService.instant(
                'main.add-devices.error.' + messageError
              ),
              key: 'appMessage',
            });
          }
        );
    } else {
      this.addNewDeviceForm.controls.deviceId.markAsTouched();
      this.addNewDeviceForm.controls.locatorPin.markAsTouched();
    }
  }

  onDeleteDevice(device): void {}

  ngOnInit() {}

  addNewDevice(): void {
    this.addingDevice = true;
  }
}
